import { render, staticRenderFns } from "./CalculateResultPage.vue?vue&type=template&id=71381b59"
import script from "./CalculateResultPage.vue?vue&type=script&lang=js"
export * from "./CalculateResultPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports